<template>
	<div class="tabbar">
		<div
			class="tabbar_item"
			v-for="(item, index) in tabBar"
			:key="index"
			@click="() => handleSkip(item)"
		>
			<!-- <img
				class="tabbar_item_icon"
				:src="active === item.id ? item.iconSelect : item.icon"
			/> -->
			<div
				:class="
					active === item.id
						? 'tabbar_item_text active'
						: 'tabbar_item_text'
				"
			>
				{{ item.text }}
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		active: {
			type: Number,
			default: 1
		}
	},
	data() {
		return {
			tabBar: [
				{
					id: 1,
					// icon:
					// 	"",
					// iconSelect:
					// 	"",
					path: "/question/task",
					text: "我的任务"
				},
				{
					id: 2,
					// icon:
					// 	"",
					// iconSelect:
					// 	"",
					path: "/question/message",
					text: "我的消息"
				}
			]
		};
	},
	methods: {
		handleSkip({ path }) {
			this.$router.push({
				path
			});
			// let { origin } = window.location;
			// window.location.href = `${origin}${path}`;
		}
	}
};
</script>

<style>
.tabbar {
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-around;
	position: fixed;
	bottom: 0;
	left: 0;
	background: #ffffff;
	z-index: 9;
	padding-bottom: env(safe-area-inset-bottom);
}
.tabbar_item {
	flex: 1;
	height: 0.49rem;
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
}
.tabbar_item_icon {
	width: 0.28rem;
	height: 0.28rem;
}
.tabbar_item_text {
	font-size: 0.12rem;
	color: #969696;
	transform: scale(0.8);
}
.tabbar_item_text.active {
	color: #141414;
}
</style>



// WEBPACK FOOTER //
// src/app/components/tabBar.vue